import { IVisibleBlocksState } from "../types";

export const defaultVisibleBlocks: IVisibleBlocksState = {
  premiseBlock: true,
  accountBlock: false,
  electricityBlock: false,
  gasLineBlock: false,
  gasBothBlock: false,
  gasMeterBlock: false,
  internetBlock: false,
  closeTransferBlock: false,
};
